import { dutchNumberStringToIntl } from "src/functions/numberFormatter";
var NLEURO = new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
});
export var formatPrice = function (cents) {
    return NLEURO.format(cents / 100);
};
export var parsePrice = function (price) {
    var euroPrice = Number(dutchNumberStringToIntl(price));
    // Use Math.round to fix float precision
    return Math.round(euroPrice * 100);
};
